import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";
import tokens from "@/theme/tokens";

/**
 * Shared between step one and step two, which used to share createHub.scss.
 */
export const formSx: SystemStyleObject<Theme> = {
  m: tokens.space.px20,
  // Only the hidden logo file input is still a native element (step two) —
  // it stays unstyled from here and is hidden by its own selector.
  "& input": { m: 0 },
};

export const titleSx: SystemStyleObject<Theme> = {
  color: "primary.main",
  mb: tokens.space.px30,
  textTransform: "uppercase",
};

export const questionSx: SystemStyleObject<Theme> = {
  m: tokens.space.createHubQuestionMargin,
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  alignItems: "flex-start",
};

/** Step two's Logo question — the only field left with a hand-rolled label,
 * since its native file input is a deliberate exception (see the component). */
export const labelSx: SystemStyleObject<Theme> = {
  width: 300,
  display: "inline-block",
  textTransform: "uppercase",
  mb: { xs: tokens.space.px10, lg: 0 },
};

export const pageIndexSx: SystemStyleObject<Theme> = {
  color: "grey.600",
  mr: tokens.space.px15,
};

export const requiredPromptSx: SystemStyleObject<Theme> = {
  color: tokens.color.accentTeal,
  textTransform: "lowercase",
  fontSize: tokens.fontSize.requiredPrompt,
  display: "block",
  textAlign: "right",
  mb: tokens.space.px10,
};

export const buttonRowSx: SystemStyleObject<Theme> = {
  width: 1,
  my: tokens.space.px10,
  justifyContent: "flex-end",
  alignItems: "center",
};
